<!--购买渠道下拉框-->
<script>
import api from "@/api/projectApi";

export default {
  name: 'buyChannelNameSelect',
  props: ['buyChannelName'],
  mounted() {
    this.loadData()
  },
  data() {
    return {
      options: []
    }
  },
  methods: {
    changeSelect() {
      this.$emit('update:buyChannelName', this.buyChannelName)
    },

    clear() {
      this.$emit('update:buyChannelName', null)
    },

    loadData() {
      this.$http.post(api.basBuyChannel.getListDataUrl, {}).then(res => {
        this.options = res.data.data
      })
    }
  }
}
</script>

<template>
  <div>
    <el-select v-model="buyChannelName" @change="changeSelect" @clear="clear" :clearable="true">
      <el-option v-for="item in options"
                 :key="item.id"
                 :label="item.buyChannelName"
                 :value="item.buyChannelName"
      ></el-option>
    </el-select>
  </div>
</template>

<style scoped lang="scss">

</style>
